import { DisplayMode } from '@rta/rta-blueprint-component';

import { Controller } from '@context';
import { type CapturedLogEntry, getCapturedLogs } from '../../../utils/console-capture';
import { releaseInfo } from '../../../config';

export type DiagnosticsMeta = {
	timestamp: string;
	release: string;
	build: string;
	commit: string;
	userEmail: string | null;
	customerName: string;
	blueprintId: string;
	kitchenVersion: number | null;
	displayMode: DisplayMode | null;
	userAgent: string;
};

export type DiagnosticsBundle = {
	meta: DiagnosticsMeta;
	blueprint: Record<string, unknown> | null;
	logs: Array<CapturedLogEntry>;
};

export type BuildDiagnosticsBundleParams = {
	controller: Controller | null;
	userEmail: string | null;
	customerName: string;
	blueprintId: string;
};

export const buildDiagnosticsBundle = (params: BuildDiagnosticsBundleParams): DiagnosticsBundle => {
	const { controller, userEmail, customerName, blueprintId } = params;
	const displayMode = (controller as unknown as { navigation?: { displayMode?: DisplayMode } })?.navigation?.displayMode ?? null;

	return {
		meta: {
			timestamp: new Date().toISOString(),
			release: releaseInfo.release,
			build: releaseInfo.build,
			commit: releaseInfo.commit,
			userEmail,
			customerName,
			blueprintId,
			kitchenVersion: controller?.kitchen?.version ?? null,
			displayMode,
			userAgent: navigator.userAgent
		},
		blueprint: controller?.kitchen?.context?.blueprint?.serialize() ?? null,
		logs: getCapturedLogs()
	};
};
